import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Box, Button, Column, DatePicker, Popover, TextField, Typography } from 'seagull';
import { toDateOrNull, toIsoDate } from 'seagull/utils/isoDate';
import { getTestIds } from 'seagull/utils/TestIds';
import { FilterChip } from '~/components/AiSearchChips/FilterChip/FilterChip';
import styles from './OrValueGroupChip.module.scss';
import { isValidDraft } from './OrValueGroupChip.utils';
export const GetOrValueGroupChipTID = (parentTestId)=>getTestIds(parentTestId);
export const OrValueGroupChip = (param)=>{
    let { testId, field, fields, values, connectorTone, tone, texts, bi, onValueChange, onRemove } = param;
    var _ref;
    const { OrValueGroupChipTestIds } = useMemo(()=>GetOrValueGroupChipTID(testId), [
        testId
    ]);
    const [editor, setEditor] = useState(null);
    const descriptor = fields[field];
    const editorKind = descriptor.editor;
    const openEditor = (index)=>(event)=>{
            setEditor({
                index,
                draft: values[index].value,
                anchorEl: event.currentTarget,
                showValidationError: false
            });
        };
    const closeEditor = ()=>setEditor((current)=>current == null ? null : _object_spread_props(_object_spread({}, current), {
                anchorEl: null
            }));
    const setDraft = (draft)=>setEditor((current)=>current == null ? null : _object_spread_props(_object_spread({}, current), {
                draft,
                showValidationError: false
            }));
    const apply = (open)=>{
        const trimmed = open.draft.trim();
        if (!isValidDraft(editorKind, trimmed)) {
            setEditor(_object_spread_props(_object_spread({}, open), {
                showValidationError: true
            }));
            return;
        }
        closeEditor();
        if (values[open.index] != null) {
            onValueChange(open.index, trimmed.length === 0 ? undefined : trimmed);
        }
    };
    const handleEditorKeyDown = (open)=>(event)=>{
            if (event.key === 'Enter') {
                event.preventDefault();
                apply(open);
            }
        };
    const valueSegments = values.map((entry, index)=>({
            label: entry.label,
            onClick: openEditor(index)
        }));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FilterChip, {
                testId: testId,
                fieldLabel: descriptor.label,
                valueSegments: valueSegments,
                combinator: connectorTone === 'or' ? texts.connector.or : texts.connector.and,
                tone: tone,
                onRemove: onRemove,
                removeBiName: bi.remove.name
            }),
            /*#__PURE__*/ _jsx(Popover, {
                testId: OrValueGroupChipTestIds.EditPopover(),
                open: (editor === null || editor === void 0 ? void 0 : editor.anchorEl) != null,
                anchorEl: (_ref = editor === null || editor === void 0 ? void 0 : editor.anchorEl) !== null && _ref !== void 0 ? _ref : null,
                onClose: closeEditor,
                children: editor != null && /*#__PURE__*/ _jsx(Box, {
                    padding: 12,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 8,
                        children: [
                            editorKind === 'date' ? /*#__PURE__*/ _jsx(DatePicker, {
                                testId: OrValueGroupChipTestIds.EditDatePicker(),
                                bi: bi.edit,
                                value: toDateOrNull(editor.draft),
                                onChange: (date)=>setDraft(date == null ? '' : toIsoDate(date)),
                                popperClassName: styles.calendarPopper,
                                disableErrors: true
                            }) : /*#__PURE__*/ _jsx(TextField, {
                                testId: OrValueGroupChipTestIds.EditTextField(),
                                bi: bi.edit,
                                value: editor.draft,
                                suffix: descriptor.suffix,
                                onChange: (event)=>setDraft(event.target.value),
                                inputProps: {
                                    onKeyDown: handleEditorKeyDown(editor)
                                },
                                autoFocus: true
                            }),
                            editor.showValidationError && /*#__PURE__*/ _jsx(Typography, {
                                testId: OrValueGroupChipTestIds.ValidationError(),
                                skin: "error",
                                variant: "paragraph2",
                                children: descriptor.validationError
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                testId: OrValueGroupChipTestIds.ApplyButton(),
                                bi: bi.apply,
                                onClick: ()=>apply(editor),
                                children: texts.apply
                            })
                        ]
                    })
                })
            })
        ]
    });
};
